import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openContentFullscreen } from '../../actions/contentFullscreen';
import { ChatImage } from '../../components/ChatImage';
import { currentOpenChatIDSelector } from '../../selectors';
import { IImageFile } from '../../types/imageFile';
import { ETelemetryEvents } from '../../types/telemetry';
import { useApplicationContext } from '../../utils/applicationContext';
import { getFileSrc } from '../../utils/getFileSrc';

interface IChatImageProps {
  // Изображение
  image: IImageFile;
  // Флаг о том, что это элемент галереи с несколькими фото
  isGalleryItem?: boolean;
  withFullscreen?: boolean;
  withSave?: boolean;
  onSave?: () => void;
}

export const ChatImageContainer: React.FC<IChatImageProps> = ({
  image,
  isGalleryItem,
  withFullscreen,
  withSave,
  onSave,
}) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [isError, setIsError] = React.useState(false);

  const chatId = useSelector(currentOpenChatIDSelector);
  const { telemetry } = useApplicationContext();

  const imageEl = React.useRef<HTMLImageElement>(null);

  const { uid } = image;

  const src = getFileSrc(uid, chatId);

  const dispatch = useDispatch();

  const handleError = () => {
    setIsLoading(false);
    setIsError(true);

    telemetry.increment(ETelemetryEvents.ChatFileDownloadFail);
  };

  const handleLoad = () => {
    setIsLoading(false);
    telemetry.increment(ETelemetryEvents.ChatFileDownloadSuccess);

    /* istanbul ignore next-line */
    if (imageEl.current?.naturalWidth === 0) {
      setIsError(true);
      telemetry.increment(ETelemetryEvents.ChatFileDownloadFail);
    }
  };

  const handleClick = () => {
    if (withFullscreen && !isError) {
      dispatch(openContentFullscreen({ selectedImageUid: uid }));
    }
  };

  return (
    <ChatImage
      ref={imageEl}
      src={src}
      image={image}
      onLoad={handleLoad}
      onError={handleError}
      onClick={handleClick}
      onSave={onSave}
      isLoading={isLoading}
      isError={isError}
      withSave={withSave}
      isGalleryItem={isGalleryItem}
    />
  );
};
